import { ArrowBack, OpenInNew } from '@mui/icons-material'
import { Box, Button, Link, Stack, Typography } from '@mui/material'
import { EPLITrainerDevelopmentPlanList } from '../../EPLITrainerDevelopmentPlanList'
import { EPLI_URL } from '../../../../../constants/gvsuLinks'

interface Props {
  priorityId: number
  annualPLanId: number
  orgId: number
  readOnly: boolean
  trackingReadonly: boolean
  implementationPhase?: boolean
  onBack: () => void
  planOrgId: number
  handleViewContract?: () => void
}

export const EPLITrainerDevelopmentPlan = (props: Props): JSX.Element => {
  const epliLink = (
    <Link sx={{ cursor: 'pointer' }} onClick={() => { window.open(EPLI_URL, '_blank') }}>
      Effective Practices Leadership Initiative (EPLI) webpage
    </Link>
  )

  return <Box data-testid='epliTranerDevelopmentPlan' sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  }}
  >
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <Button
        data-testid="backPdrsButton"
        onClick={props.onBack}
        sx={{
          padding: '5px 10px',
          backgroundColor: 'var(--grey-50)',
          color: 'var(--grey-500)',
          width: 'fit-content',
          textTransform: 'none'
        }}
      >
        <ArrowBack sx={{ mr: '10px' }} />
        Professional Learning
      </Button>

      {props.implementationPhase === true && (
        <Button
          data-testid="viewContractButton"
          sx={{
            padding: '5px 10px',
            backgroundColor: 'var(--grey-50)',
            color: 'var(--grey-500)',
            width: 'fit-content',
            textTransform: 'none'
          }}
          onClick={props.handleViewContract}
        >
          View Contract
          <OpenInNew fontSize='small' sx={{ ml: '10px' }} />
        </Button>
      )}
    </Stack>

    <Typography variant='h1'>EPLI Trainer Plan</Typography>
    <Typography variant='body1'>
      List the EPLI Trainer trainings that individuals from your ISD will attend in the table below. Indicate how many individuals will attend each training series/bootcamp or training event and the budget request. Please note that this is not a registration system. To learn more about the application process for EPLI, visit the {epliLink}.
    </Typography>

    <EPLITrainerDevelopmentPlanList
      priorityId={props.priorityId}
      annualPlanId={props.annualPLanId}
      orgId={props.orgId}
      readOnly={props.readOnly}
      trackingReadonly={props.trackingReadonly}
      implementationPhase={props.implementationPhase}
      planOrgId={props.planOrgId}
    />
  </Box>
}
